var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"project-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('gf-custom-page-bar',{attrs:{"header-data":_vm.headersList[0]}}),_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }